<template>
  <div>
    <v-toolbar dark class="secondary">
      <v-icon>photo_camera</v-icon>
      <v-toolbar-title>Jobsite Photos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="canEdit" @click="showUploader = true" class="cyan"><v-icon left>add_a_photo</v-icon>Add Photos</v-btn>
    </v-toolbar>
    <uploader v-if="showUploader" @closeUploader="showUploader = false" @filesUploaded="getUploadFiles" :photos="true" :project="project" :uploadPath="'projects/' + this.project.id + '/photos/'"  />
    <p v-if="projectPhotos.length < 1" class="mt-4 ml-4 title">No Photos Have Been Added</p>
    <div>
      <vue-gallery :images="projectPhotos" :index="index" @close="index = null"></vue-gallery>
      <div
        :class="rotationClass(photo.rotate)"
        class="image"
        :key="imageIndex"
        @click="index = imageIndex"
        v-for="(photo, imageIndex) in projectPhotos"
        :style="{ backgroundImage: 'url(' + photo.thumbnailURL + ')', width: '300px', height: '300px' }"
      >
      <div v-on:click.stop :class="(imageIconRotations(photo.rotate))" :style="photo.rotate === '90' ? 'margin-left:-220px; margin-top:10px' : photo.rotate === '180' ? 'margin-right:10px; margin-top:245px' : photo.rotate === '270' ? 'margin-left:220px; margin-top:30px' : 'margin-left:10px; margin-top:20px' ">
        <v-badge color="white" style="padding-bottom: 30px">
          <v-icon @click="deletePhoto(photo); deleting = true" slot="badge" color="red" dark>cancel</v-icon>
        </v-badge>
        <v-badge color="white" style="margin-left:-4px">
          <v-icon @click="currentPhoto = photo; rotatePhoto(photo)" slot="badge" color="red" dark>rotate_right</v-icon>
        </v-badge>
      </div>
      </div>
    </div>
</div>
</template>

<script>
import Uploader from '../../helpers/Uploader'
import VueGallery from 'vue-gallery'

import _ from 'lodash'

export default {
  props: ['project'],
  data () {
    return {
      photoGallery: null,
      updateImage: true,
      currentPhoto: null,
      dialog: false,
      showUploader: false,
      index: null,
      deleting: null
    }
  },
  destroyed () {
    this.$store.dispatch('clearProjectPhotos')
  },
  mounted () {
    const payload = {project: this.project}
    this.$store.dispatch('getProjectPhotos', payload)
  },
  computed: {
    canEdit () {
      return this.permissions.edit.all || (this.permissions.edit.assigned && this.project.assigned)
    },
    permissions () {
      return this.$store.getters.user.permissions.projects
    },
    projectPhotoRotation () {
      let rotation = []
      this.projectPhotos.forEach(photo => {
        if (photo.rotate) {
          rotation.push('rotate' + photo.rotate)
        } else {
          rotation.push('rotate0')
        }
        return rotation
      })
      return rotation
    },
    projectPhotos () {
      let photoArray = []
      let photos = this.$store.getters.projectPhotos
      photos.forEach(photo => {
        photoArray.push({...photo, href: photo.url})
      })
      return _.orderBy(photoArray, ['timestamp.seconds'], ['desc'])
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    rotatePhoto (photo) {
      console.log('Current Photo', this.currentPhoto)
      const photoIndex = this.projectPhotos.findIndex(i => i.url === photo.url)
      const rotation = !this.currentPhoto.rotate || this.currentPhoto.rotate === '0' ? '90' : this.currentPhoto.rotate === '90' ? '180' : this.currentPhoto.rotate === '180' ? '270' : '0'
      this.projectPhotos[photoIndex].rotate = rotation
      // this.currentPhoto.rotate = rotation
      this.updateImage = false
      setTimeout(this.updateImage = true, 500)
      this.$store.dispatch('rotateImage', {project: this.project, photo: this.currentPhoto})
    },
    execUpdateImage () {
      this.updateImage = true
    },
    rotationClass (rotation) {
      return {
        rotate90: rotation === '90',
        rotate180: rotation === '180',
        rotate270: rotation === '270'
      }
    },
    imageIconRotations (initialRotation) {
      return {
        iconsNoRotation: initialRotation === '0',
        rotate270: initialRotation === '90',
        rotate180: initialRotation === '180',
        rotate90: initialRotation === '270'
      }
    },
    launchPhotoFullscreen (imageIndex) {
      if (!this.deleting) {
        this.index = imageIndex
      }
      const photoClass = document.querySelectorAll('.slide ')
      return photoClass
    },
    deletePhoto (photo) {
      console.log('Photo Details', photo)
      if (confirm('Are you sure you want to delete this photo?')) {
        this.$store.dispatch('deletePhoto', {project: this.project, photo: photo})
        this.dialog = false
      }
    },
    getUploadFiles (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        if (value.ref.name.startsWith('thumb')) {
          return
        }
        let selectedFileName = value.ref.name
        this.uploadedFileList.push({id: this.project.id, name: selectedFileName, thumbnail: 'thumb_' + selectedFileName, type: value.metadata.contentType, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
      })
      const payload = {id: this.project.id, project_name: this.project.name, files: this.uploadedFileList}
      this.$store.dispatch('projectPhotos', payload)
    }
  },
  components: {
    Uploader,
    VueGallery
  }
}
</script>

<style scoped>
.iconsNoRotation {
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
}
.dialogBackground {
  background-color: black;
}
.fullImage {
  position: fixed;
  top: 100px;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  overflow: auto;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.rotate90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.rotate180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.rotate270 {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
/* The Modal (background) */
.modal {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: black;
}
/* Modal Content */
.modal-content {
  /* -webkit-transform: rotate(90deg); */
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  width: 90%;
  max-width: 1200px;
}
/* The Close Button */
.close {
  color: white;
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 35px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: #999;
  text-decoration: none;
  cursor: pointer;
}
.mySlides {
  display: none;
}
.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectPhotos.vue